import { useEffect, useState } from 'react';
import './Profile.css';
import useUser from '../../hooks/useUser';
import EventItem from '../../components/EventItem/EventItem';

import telegramIcon from '../../assets/images/icons/tg_icon.svg';
import instIcon from '../../assets/images/icons/inst_icon.svg';
import phoneIcon from '../../assets/images/icons/tel_icon.svg';

import ClassicButton from '../../components/UI/ClassicButton/ClassicButton';
import { getUserEvents } from '../../http/eventAPI';
import { IEventItem } from '../../interfaces/IEventItem';
import useScreenWidth from "../../hooks/useScreenWidth";

const renderEventItems = (events: IEventItem[], limit: number) => {
    return events.slice(0, limit).map(event => (
        <EventItem
            key={`${event.id}-${event.eventDate}`}
            id={event.id}
            title={event.title}
            location={event.location}
            image={event.image}
            eventDate={event.eventDate}
            dateId={event.dateId}
        />
    ));
};

const Profile: React.FC = () => {
    const user = useUser();
    const [userEvents, setUserEvents] = useState<IEventItem[]>([]);
    const [pagination, setPagination] = useState<boolean>(false);
    const [filteredEvents, setFilteredEvents] = useState<IEventItem[]>([]);
    const [activeFilter, setActiveFilter] = useState<'past' | 'upcoming' | 'all'>('upcoming');
    const [isVisible, setVisible] = useState<boolean>(false);

    useEffect(() => {
        setVisible(true);
    }, []);
    
    useEffect(() => {
        if (user.user) {
            getUserEvents(user.user.userId)
                .then((response) => {
                    console.log("Ответ на запрос событий:", response);
                    if (Array.isArray(response)) {
                        setUserEvents(response);
                        filterEvents(response, 'upcoming');
                    }
                })
                .catch((error) => {
                    console.log('Ошибка при получении информации о событиях:', error);
                });
        }
    }, [user]);
    
    useEffect(() => {
        if (userEvents.length > 0) {
            filterEvents(userEvents, 'upcoming');
        }
    }, [userEvents]);
    
    const handlePagination = () => {
        setPagination(true);
    };
    
    const filterEvents = (events: IEventItem[], filter: 'past' | 'upcoming' | 'all') => {
        const now = new Date();
        let filtered;
        
        switch (filter) {
            case 'past':
                filtered = events.filter(event => new Date(event.eventDate) < now);
                break;
            case 'upcoming':
                filtered = events.filter(event => new Date(event.eventDate) >= now);
                break;
            case 'all':
                filtered = events;
                break
        }
        
        setFilteredEvents(filtered);
        setActiveFilter(filter);
    };
    
    return (
        <div className={`profile ${isVisible ? 'visible' : ''}`}>
            <div className="profile_contacts">
                <a className="profile_contact" href='tel:+79119019000'>
                    <img src={phoneIcon} alt="phone"/>
                </a>

                <a className="profile_contact"
                   href='https://www.instagram.com/miartcomprostranstvo?igsh=Y2Y2M2JyZXh2bmN2&utm_source=qr'
                   target='_blank' rel="noreferrer">
                    <img src={instIcon} alt="vk"/>
                </a>

                <a className="profile_contact" href='https://t.me/MIARTCOM2023' target='_blank' rel="noreferrer">
                    <img src={telegramIcon} alt="telegram"/>
                </a>
            </div>

            <div className='profile_firstContainer'>
                <div className="profile_header">
                    <h2>Мои билеты</h2>

                    <div className="profile_header_filters">
                        <div
                            className={`profile_header_filter ${activeFilter === 'past' ? 'active' : ''}`}
                            onClick={() => filterEvents(userEvents, 'past')}
                        >
                            Прошедшие
                        </div>
                        <div
                            className={`profile_header_filter ${activeFilter === 'upcoming' ? 'active' : ''}`}
                            onClick={() => filterEvents(userEvents, 'upcoming')}
                        >
                            Предстоящие
                        </div>
                        <div
                            className={`profile_header_filter ${activeFilter === 'all' ? 'active' : ''}`}
                            onClick={() => filterEvents(userEvents, 'all')}
                        >
                            Все события
                        </div>
                    </div>
                </div>

                <div className="profile_events">
                    {filteredEvents.length > 0 ? (
                        <>
                            {!pagination ? renderEventItems(filteredEvents, 3) :
                                filteredEvents.map(event => (
                                    <EventItem
                                        key={`${event.id}-${event.eventDate}`}
                                        id={event.id}
                                        title={event.title}
                                        location={event.location}
                                        image={event.image}
                                        eventDate={event.eventDate}
                                        dateId={event.dateId}
                                    />
                                ))
                            }
                        </>
                    ) : (
                        <div className='profile_eventsNull'>Нет событий</div>
                    )}
                </div>
            </div>

            <div className="profile_pagination">
                {(!pagination && filteredEvents.length > 3) && (
                    <ClassicButton
                        padding="10px 15px"
                        bgColor="#ffe5cc"
                        fontColor="#754737"
                        fontSize='clamp(15px, 1.2vw, 30px)'
                        fontFamily="Actay Regular"
                        onClick={handlePagination}
                    >
                        Показать больше
                    </ClassicButton>
                )}
            </div>
        </div>
    );
};

export default Profile;
